import EmbedComp from '@scbd/self-embed-vue-component'

const VERSION       = process.env.VUE_APP_VERSION
const COMP_CSS_URL  = `https://unpkg.com/@scbd/conference-cal@latest/dist/lib/ConferenceCal.css?version=${VERSION}`
const COMP_JS_URL   = `https://unpkg.com/@scbd/conference-cal@latest?version=${VERSION}`


const options = {
  selfID            : 'ConferenceCal',
  appID             : 'appId',
  compName          : 'ConferenceCal', //required
  scriptDependancies: [COMP_JS_URL], // required comp to load
  cssDependancies   : [COMP_CSS_URL],
  i18n              : false,
  propsData         : {}
}
const self = document.getElementById(options.selfID)
const code = self.getAttribute('data-code')

options.propsData.code = code

EmbedComp.setOptions(options)